import { apiRequest } from './index';

export const fetchPayLevelRequest = ( id, success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest('/pay-levels/' + id, {}, success, failure);
};

export const fetchPayLevelsRequest = ( success = (result = []) => {}, failure = (error) => {}) => {
    apiRequest('/pay-levels', {}, success, failure);
};

export const createPayLevelRequest = ( data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/pay-levels',
        { 
            method: 'POST',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
};

export const editPayLevelRequest = ( id, data, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/pay-levels/' + id,
        { 
            method: 'PUT',
            body: JSON.stringify(data)
        },
        success,
        failure
    )
};

export const deletePayLevelRequest = ( id, success = (result = []) => {}, failure = (error) => {}) =>{
    apiRequest(
        '/pay-levels/' + id,
        { method: 'DELETE' },
        success,
        failure
    )
};

const buildPayLevelOptions = payLevel => ({
    value: payLevel ? payLevel._id : '',
    label: payLevel ? `${payLevel.payLevelName} - ${payLevel.area?.areaName || "N/A"}` : '',
    data: payLevel
});

export const payLevelSelectOptionRequest = (success = (result = []) => {}, failure = (error) => {}) =>{
    fetch(process.env.REACT_APP_API_ENDPOINT + '/pay-levels')
        .then(response => response.json())
        .then(data => {
            const selectOptions = [];
            data.forEach((item) => {
                const option = buildPayLevelOptions(item);
                selectOptions.push(option);
            });
            success(selectOptions);
        })
        .catch(error =>{
            failure(error.status);
        });
}